import React, { Component } from 'react'

// modules
import { COLOR, FILTERS, KEY_VALUES, LAYOUT } from "../modules/constants"

// mui
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { withStyles } from "@mui/styles"

import Tooltip from '@mui/material/Tooltip'

const width = LAYOUT.LANDSCAPE_MENU_WIDTH - (2 * LAYOUT.COLUMN_PADDING) + LAYOUT.ICON_SHIFT;

const styles = theme => ({
  root: {
  },
  iconButton: {
    marginRight: 0,
    marginTop: 2,
    marginBottom: 2,
    marginLeft: -LAYOUT.ICON_SHIFT,
    paddingTop: 2,
    paddingBottom: 2,
    height: 35,
    fontSize: 14,
    justifyContent: "left",
    borderRadius: 5, // makes hover shape nearly rectangular, rather than oval
  },
  iconLabel: {
    fontSize: 14,
    fontWeight: "bold",
    marginLeft: 7,
    marginTop: 4,
    textAlign: "left",
  },
})

class NumerableIconButton extends Component {

  render() {
    const { classes, item, portrait } = this.props
    // console.log('NumerableIconButton this.props:', this.props)

    const disabled = item.isMenuHeading ?? item.disabled

    return (
      <Tooltip arrow
        title={disabled ? item.tipDisabled ?? "" : item.tipEnabled ?? ""}
        placement="top" disableFocusListener disableInteractive
        enterDelay={KEY_VALUES.TOOLTIP_DELAY}
        leaveDelay={0}
      >
        <span>

          <IconButton
            aria-haspopup={item.ariaHaspopup}
            aria-owns={item.ariaOwns}
            className={classes.iconButton}
            color="primary"
            disabled={disabled}
            // If onMouseEnter not null, then call this, otherwise call item.handleClick
            // ( onMouseEnter sometimes may not work if moved from other menu )
            onClick={item.onMouseEnter ?? (() => { item.handleClick() })}
            onMouseEnter={item.onMouseEnter}
            onMouseOver={item.onMouseOver}
            size="small"
            style={{
              color: item.isMenuHeading ? COLOR.BLACK : item.color,
              justifyContent: "left",
              marginLeft: -LAYOUT.ICON_SHIFT,
              // These buttons sit inline and wrap onto multiple lines when there isn't room for
              // them all on one row - in portrait the class's default 2px top/bottom margin (4px
              // between wrapped rows) is too tight a touch target gap for mobile.
              ...(portrait ? { marginTop: 8, marginBottom: 8 } : {}),
              paddingLeft: item.isMenuHeading ? 7 : (item.paddingLeft ?? LAYOUT.ICON_SHIFT),
              paddingRight: item.paddingRight,
              width: item.width ?? width,
            }}
          >
            {item.image
              ? <img // if there is an image, show it
                alt={item.label}
                src={item.image}

                // image should be black on transparent for coloring filter to work OK
                style={{
                  height: 24, marginTop: 4, marginBottom: 2,
                  filter: `${disabled ? "invert(0.75)" : FILTERS.BLACK_TO_BRAND}`
                }}
              />
              // if no image, show an icon
              : item.icon
            }

            <Typography className={classes.iconLabel} style={{ fontSize: 14, fontWeight: item.fontWeight ?? "bold", marginLeft: 6, marginTop: 4, color: "inherit", textAlign: "left" }}>
              {item.label}
            </Typography>
          </IconButton>
        </span>
      </Tooltip >
    )
  }
}

// @ts-ignore
export default withStyles(styles)(NumerableIconButton)
